import {
  Card,
  CardContent,
  Grid,
  GridList,
  GridListTile,
  IconButton,
  GridListTileBar,
  ButtonGroup
} from '@material-ui/core';
import PhotoIcon from '@material-ui/icons/Photo';
import DescriptionIcon from '@material-ui/icons/Description';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import AlertYasal from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import 'react-html5-camera-photo/build/css/index.css';
import { useTranslation } from 'react-i18next';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { saveFotograf, base64Reader } from 'src/utils/storage/StrPhoto';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  },
  gridList: {
    width: 500,
    height: 450
  },
  icon: {
    color: 'rgba(255, 255, 255, 0.54)'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  divider: {
    backgroundColor: '#1D3343'
  },
  formControl: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));

function FileUpload({ onClose, fileList, deleteFile }) {

  const Compress = require('compress.js');
  const compress = new Compress();
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [label, setLabel] = useState(t('PhotoType0'));
  const [DosyaTipi, setDosyaTipi] = useState('FleetPhoto')
  const [DosyaTipiText, setDosyaTipiText] = useState('FleetPhotoTitle')

  const getUploadParams = ({ meta }) => { return { url: 'https://httpbin.org/post' } }

  const handleChangeStatus = ({ meta, file }, status) => { }

  const handleSubmit = async (files, allFiles) => {
    const result = []
    if (!window.navigator.onLine) {
      // offline
      files.forEach(f => {
        let reader = new FileReader();
        reader.onload = function (base64) {
          saveFotograf(
            0,
            base64.target.result,
            DosyaTipi,
            f.meta.name,
            f.meta.type
          );
        };
        reader.readAsDataURL(f.file);
      });
      allFiles.forEach(f => f.remove());
      setLabel(t('lblOfflineFileControl'));
    } else {
      const total = files.length;
      let success = 0;
      for (let i = 0; i < files.length; i++) {
        const { file } = files[i];
        const { meta } = files[i];
        let base64Result = '';
        if (meta.type.indexOf('image') !== -1) {
          const resizedImage = await compress.compress([file], {
            size: 0.3, // the max size in MB, defaults to 2MB
            quality: 1, // the quality of the image, max is 1,
            maxWidth: 1920, // the max width of the output image, defaults to 1920px
            maxHeight: 1920, // the max height of the output image, defaults to 1920px
            resize: true // defaults to true, set false if you do not want to resize the image width and height
          });
          const img = resizedImage[0];
          base64Result = img.data;
        } else {
          base64Result = await base64Reader(file);
        }

        const data = {
          Title: `${meta.name}`,
          MIMEType: meta.type,
          FileType: DosyaTipi.toString(),
          FileData: base64Result
        };

        const config = {
          headers: { 'Content-Type': 'application/json' }
        };
        result.push(data)
      }

      if (total === 0) {
        setLabel(t('PhotoType0'));
      }

      onClose(result)
    }
  };

  const handleDetayAc = (event, dosya) => {
    const linkSource = `data:${dosya.MIMEType};base64,${dosya.FileData}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = dosya.Title;
    downloadLink.click();
  };

  const handleDelete = (event, photo) => {
    deleteFile(photo)
  };

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} justify="space-between">
          <Grid item xs={12} align="right">
            <Dropzone
              onChangeStatus={handleChangeStatus}
              onSubmit={handleSubmit}
              maxFiles={30}
              minSize={0}
              maxSize={8072000}
              accept="*"
            />

          </Grid>
          {fileList.length > 0 && (
            <>
              <GridList cellHeight={150} className={classes.gridList}>
                {fileList.map(tile => (
                  <GridListTile key={tile.Id}>
                    <IconButton
                      onClick={event => handleDetayAc(event, tile)}
                      aria-label={`büyük resim ${tile.FileName}`}
                    >
                      {tile.FileType === 'image/jpeg' ||
                        tile.FileType === 'image/png' ||
                        tile.FileType === 'image/gif' ? (
                        <PhotoIcon fontSize="large" className={classes.imageFull} />
                      ) : tile.FileType === 'application/pdf' ? (
                        <PictureAsPdfIcon fontSize="large" />
                      ) : (
                        <DescriptionIcon fontSize="large" />
                      )}
                    </IconButton>
                    <GridListTileBar
                      title={tile.Title}
                      actionIcon={
                        <ButtonGroup
                          color="primary"
                          aria-label="outlined primary button group"
                        >
                          <IconButton
                            onClick={event =>
                              handleDelete(event, tile)
                            }
                            aria-label={`Delete ${tile.FileName}`}
                            className={classes.icon}
                          >
                            <DeleteForeverIcon color="error" />
                          </IconButton>
                        </ButtonGroup>
                      }
                    />
                  </GridListTile>
                ))}
              </GridList>
            </>
          )}
        </Grid>
        <br></br>
        <br></br>
        <AlertYasal severity="warning">{t('yasal_uyari')}</AlertYasal>
      </CardContent>
    </Card>
  );
}

FileUpload.propTypes = {
  className: PropTypes.string
};

export default FileUpload
